import {getPrivateAxios} from '../../libs';
import {Guide, PaginatedQuery} from './types';

export interface FetchGuideParams {
  filter?: {
    search?: string;
    owned?: boolean;
    favorites?: boolean;
    trash?: boolean;
  };
  sort?: 'createdAt' | 'updatedAt' | 'name';
  page?: number;
  take?: number;
}

/**
 * Fetch guides with pagination
 * @param params
 */
export const fetchGuides = async (params: FetchGuideParams) => {
  const {data} = await getPrivateAxios().get<PaginatedQuery<Guide>>('/guides', {
    params,
  });
  return data;
};
